<template lang="pug">
el-dialog(
  :model-value="modelValue"
  @update:model-value="$emit('update:modelValue', $event)"
  title="Add Workflow"
  top="5vh" width="100%"
  class="el-dialog__max-w-700"
  :close-on-click-modal="false"
)
  el-form(
    ref="refForm",
    :rules="rules",
    :model="item"
    status-icon
    label-position="top"
  )
    .row
      .col
        el-form-item(
          label="Title"
          prop="title"
        )
          el-input(v-model="item.title")
    .row
      .col
        el-form-item(
          label="Todos"
          prop="todoIds"
        )
          el-select(v-model="item.todos" multiple placeholder="Select").w-100
            el-option(
              v-for="item in todoItems.items"
              :key="item.id"
              :label="item.todo"
              :value="item.id"
            )
  template(#footer)
    el-button(type="success" @click="validateForm" v-loading="loading") Add Workflow

</template>

<script>
import {
  defineComponent,
  ref, reactive,
  onMounted,
} from 'vue';
import { requiredRule } from '@/data/rules';
import shared from '../shared';

export default defineComponent({
  name: 'DialogAddWorkflow',
  props: {
    modelValue: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'close-dialog', 'save-item'],
  setup(_, { emit }) {
    const {
      doFindTodos,
    } = shared();

    const refForm = ref(null);
    const item = reactive({
      id: null,
      title: '',
    });
    const todoItems = reactive({ items: [] });
    const rules = {
      title: requiredRule('title'),
    };

    onMounted(async () => {
      todoItems.items = await doFindTodos();
    });

    function submitForm() {
      emit('save-item', item);
      emit('close-dialog');
    }

    function validateForm() {
      refForm.value.validate((valid) => {
        if (valid) return submitForm();
        console.log('error on submiit!!');
        return false;
      });
    }
    return {
      refForm,
      rules,
      item,
      todoItems,
      validateForm,
    };
  },
});

</script>
